/* eslint-disable import/prefer-default-export */
import { isBoolean, isEmpty, isString } from 'lodash'

import { assetTypeOptions } from './data'

import { AssetTypes, CreateAssetInput, FilterAssetsInput } from '~generated/types'

export function getOrganizationAssetTypeOptions(haveGTM: boolean) {
  return haveGTM ? assetTypeOptions : assetTypeOptions.filter((option) => option.value !== AssetTypes.SALES_ENABLEMENT)
}

export function extractCreateAssetInputFromFilter(filter: FilterAssetsInput): Partial<CreateAssetInput> {
  return {
    ...(isString(filter?.query) && !!filter.query.trim() && { name: filter.query.trim() }),
    ...(!isEmpty(filter?.types) && { type: filter.types[0] }),
    ...(!isEmpty(filter?.tagIds) && { tagsIds: filter.tagIds }),
    ...(!isEmpty(filter?.launchIds) && { launchIds: filter.launchIds }),
    ...(isBoolean(filter?.isBrandAsset) && { brandAsset: filter.isBrandAsset }),
  }
}
